<template>
  <nav>
    <v-toolbar flat app dense class="grey darken-3 pa-0">
      <!-- <v-toolbar-side-icon @click="mini = !mini" class="white--text"></v-toolbar-side-icon> -->
      <v-btn v-if="breakpoint.smAndUp" icon dark @click="mini = !mini">
        <!-- <v-icon>view_list</v-icon> -->
        <v-icon v-if="mini">chevron_right</v-icon>
        <v-icon v-if="!mini">chevron_left</v-icon>
      </v-btn>
      <!-- Home button to dashboard on mobile -->
      <v-btn
        v-else
        v-show="showDashboardIcon"
        icon
        dark
        to="/"
      >
        <v-icon>dashboard</v-icon>
      </v-btn>
      <!-- Back button on exercise description mobile screen -->
      <v-btn
        v-show="breakpoint.xsOnly === true && showExerciseDescription === true"
        @click="returnToExerciseList"
        icon
        dark
      >
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <!-- Back button on create exercise settings mobile screen -->
      <v-btn v-show="showBackToSoundSequenceListButton" @click="showSoundSequenceList" icon dark>
        <v-icon>chevron_left</v-icon>
      </v-btn>

      <v-toolbar-title class="grey--text text--darken-1 headline headline-logo hidden-sm-and-down">
        <img class="eb-logo mr-2" src="images/earbeater-logo.svg" alt="EarBeater" />
        <span class="white--text headline">Ear</span>
        <span class="orange--text font-weight-light">Beater</span>
        <span class="white--text caption font-weight-light">WEB</span>
      </v-toolbar-title>
      <div class="discipline-title">
        <h2 class="white--text">{{routeTitle}}</h2>
      </div>

      <v-spacer></v-spacer>
      <!-- Sign in and sign up -->
      <SignUpLoginMenuAndButtons />

      <UserMenu v-show="!routeTitle.includes('Create') || breakpoint.smAndUp === true"/>

      <!-- Show right navigation arrow on sound sequence list in create mode -->
      <v-btn v-show="showContinueToExerciseSettingsButton" @click="showExerciseSettings" icon dark>
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Sign up dialog -->
    <SignUp />

    <!-- Log in dialog -->
    <LogIn />

    <!-- Log in to access dialog -->
    <LogInToAccessDialog />
    <DataCopiedToDatabaseDialog />

    <v-navigation-drawer
      v-if="breakpoint.smAndUp"
      v-model="drawer"
      app
      dark
      class="grey darken-3 drawer"
      :mini-variant="mini"
      permanent
      clipped
      hide-overlay
    >
      <v-list two-line class="pa-0">
        <v-list-tile router to="/">
          <v-tooltip right nudge-right="10" :disabled="!mini">
            <template v-slot:activator="{ on }">
              <v-list-tile-action v-on="on">
                <v-icon class="white--text" large>dashboard</v-icon>
              </v-list-tile-action>
            </template>
            <span>Dashboard</span>
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title class="white--text" ml-5>Dashboard</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-for="discipline in disciplines"
          :key="discipline.route"
          router
          :to="discipline.route"
        >
          <v-tooltip right nudge-right="10" :disabled="!mini">
            <template v-slot:activator="{ on }">
              <v-list-tile-action height="300" v-on="on" v-html="discipline.icon"></v-list-tile-action>
            </template>
            <span>{{discipline.text}}</span>
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title class="white--text ml-3">{{ discipline.text }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="navigateToFeedbackForm">
          <v-tooltip right nudge-right="10" :disabled="!mini">
            <template v-slot:activator="{ on }">
              <v-list-tile-action v-on="on">
                <v-icon class="white--text" large>feedback</v-icon>
              </v-list-tile-action>
            </template>
            <span>Give Feedback</span>
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title class="white--text" ml-5>Give Feedback</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- <v-list-tile @click="navigateToInstructions">
          <v-tooltip right nudge-right="10" :disabled="!mini">
            <template v-slot:activator="{ on }">
              <v-list-tile-action v-on="on">
                <v-icon class="white--text" large>help</v-icon>
              </v-list-tile-action>
            </template>
            <span>How to use EarBeater Web</span>
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title class="white--text" ml-5>Instructions</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
      </v-list>
    </v-navigation-drawer>

    <v-bottom-nav v-if="breakpoint.xsOnly" app height="70" :value="true" color="#424242">
      <v-btn
        v-for="discipline in disciplines"
        color="teal"
        :value="discipline.shortText"
        :key="discipline.route"
        router
        flat
        :to="discipline.route"
      >
        <span class="white--text small">{{ discipline.shortText }}</span>
        <span class="mb-1" v-html="discipline.icon"></span>
      </v-btn>
    </v-bottom-nav>
  </nav>
</template>

<script>
import SignUpLoginMenuAndButtons from "@/components/user/SignUpLoginMenuAndButtons";
import SignUp from "@/components/user/SignUp";
import LogIn from "@/components/user/LogIn";
import UserMenu from "@/components/user/UserMenu";
import LogInToAccessDialog from "@/components/user/LoginToAccessDialog";
import DataCopiedToDatabaseDialog from "@/components/user/DataCopiedToDatabaseDialog";
import firebase from "firebase/app";
import db from "@/firebase/init";
export default {
  components: {
    SignUpLoginMenuAndButtons,
    SignUp,
    LogIn,
    UserMenu,
    LogInToAccessDialog,
    DataCopiedToDatabaseDialog
  },
  data() {
    return {
      drawer: true,
      mini: true,
      alreadyLoggedInAlert: {
          showing: true,
          maxWidth: '400px',
          title: 'You are already logged in!',
          text: `You are already logged in. Log out if you want to sign in with another account or create a new account.`,
          buttonText: 'OK'
        },
      disciplines: [
        {
          shortText: "Int Sizes",
          text: "Compare Interval Sizes",
          icon:
            '<svg class="discipline-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500"><g id="Layer_1"><path class="st0" d="M377 312.7V.2h-31.5c-11.6 0-21 14-21 31.3V469c0 17.3 9.4 31.2 21 31.2H398c11.6 0 21-14 21-31.2V328.4h-31.5c-5.8 0-10.5-7-10.5-15.7zM409 440c0 20.4-16.6 37-37 37s-37-16.6-37-37 16.6-37 37-37 37 16.6 37 37zM52.8 312.7V.2H21.3C9.7.2.3 14.2.3 31.5V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V328.4H63.3c-5.8 0-10.5-7-10.5-15.7zM85 440c0 20.4-16.6 37-37 37s-37-16.6-37-37 16.6-37 37-37 37 16.6 37 37zM293.4.2H262v312.5c0 8.6-4.7 15.6-10.5 15.6H220V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c0-17.2-9.4-31.3-21-31.3zM267 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM605.5 312.7V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.5c-5.8 0-10.4-7-10.4-15.7zM491.6 312.7V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4H502c-5.7 0-10.4-7-10.4-15.7zM729.4.2h-31.5v312.5c0 8.6-4.7 15.6-10.5 15.6H656V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c-.1-17.2-9.4-31.3-21-31.3zM703 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM167.3 312.7V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.5c-5.7 0-10.4-7-10.4-15.7z"/></g></svg>',
          route: "/compare-interval-sizes",
        },
        {
          shortText: "Id Intervals",
          text: "Identify Intervals",
          icon:
            '<svg class="discipline-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500"><g id="Layer_1"><path class="st0" d="M377 312.7V.2h-31.5c-11.6 0-21 14-21 31.3V469c0 17.3 9.4 31.2 21 31.2H398c11.6 0 21-14 21-31.2V328.4h-31.5c-5.8 0-10.5-7-10.5-15.7zM52.8 312.7V.2H21.3C9.7.2.3 14.2.3 31.5V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V328.4H63.3c-5.8 0-10.5-7-10.5-15.7zM293.4.2H262v312.5c0 8.6-4.7 15.6-10.5 15.6H220V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c0-17.2-9.4-31.3-21-31.3zM729.4.2h-31.5v312.5c0 8.6-4.7 15.6-10.5 15.6H656V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c-.1-17.2-9.4-31.3-21-31.3zM605.5 312.7V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.5c-5.8 0-10.4-7-10.4-15.7zM177.8 328.4c-5.8 0-10.5-7-10.5-15.6V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.4zM158 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM502.1 328.4c-5.8 0-10.5-7-10.5-15.6V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.4zM481 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37z"/></g></svg>',
          route: "/identify-intervals",
        },
        {
          shortText: "Id Chords",
          text: "Identify Chords",
          icon:
            '<svg class="discipline-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500"><g id="Layer_1"><path class="st0" d="M377 312.7V.2h-31.5c-11.6 0-21 14-21 31.3V469c0 17.3 9.4 31.2 21 31.2H398c11.6 0 21-14 21-31.2V328.4h-31.5c-5.8 0-10.5-7-10.5-15.7zM167.3 312.7V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.5c-5.7 0-10.4-7-10.4-15.7zM293.4.2H262v312.5c0 8.6-4.7 15.6-10.5 15.6H220V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c0-17.2-9.4-31.3-21-31.3zM729.4.2h-31.5v312.5c0 8.6-4.7 15.6-10.5 15.6H656V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c-.1-17.2-9.4-31.3-21-31.3zM605.5 312.7V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.5c-5.8 0-10.4-7-10.4-15.7zM63.3 328.4c-5.8 0-10.5-7-10.5-15.6V.2H21.3C9.7.2.3 14.2.3 31.5V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V328.4H63.3zM48 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM502.1 328.4c-5.8 0-10.5-7-10.5-15.6V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.4zM481 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37z"/><circle class="st0" cx="214" cy="271" r="37"/><circle class="st0" cx="652" cy="271" r="37"/></g></svg>',
          route: "/identify-chords",
        },
        {
          shortText: "Id Chord Inv",
          text: "Identify Chord Inversions",
          icon:
            '<svg class="discipline-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500"><g id="Layer_1"><path class="st0" d="M377 312.7V.2h-31.5c-11.6 0-21 14-21 31.3V469c0 17.3 9.4 31.2 21 31.2H398c11.6 0 21-14 21-31.2V328.4h-31.5c-5.8 0-10.5-7-10.5-15.7zM167.3 312.7V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.5c-5.7 0-10.4-7-10.4-15.7zM729.4.2h-31.5v312.5c0 8.6-4.7 15.6-10.5 15.6H656V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c-.1-17.2-9.4-31.3-21-31.3zM491.6 312.7V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4H502c-5.7 0-10.4-7-10.4-15.7zM63.3 328.4c-5.8 0-10.5-7-10.5-15.6V.2H21.3C9.7.2.3 14.2.3 31.5V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V328.4H63.3zM48 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM615.9 328.4c-5.8 0-10.5-7-10.5-15.6V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.4zM595 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM293.4.2H262v312.5c0 8.6-4.7 15.6-10.5 15.6H220V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c0-17.2-9.4-31.3-21-31.3zM267 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37z"/></g></svg>',
          route: "/identify-chord-inversions",
        },
        {
          shortText: "Id Scales",
          text: "Identify Scales",
          icon:
            '<svg class="discipline-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500"><g id="Layer_1"><path class="st0" d="M63.3 328.4c-5.8 0-10.5-7-10.5-15.6V.2H21.3C9.7.2.3 14.2.3 31.5V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V328.4H63.3zM48 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM177.8 328.4c-5.8 0-10.5-7-10.5-15.6V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.4zM157 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM615.9 328.4c-5.8 0-10.5-7-10.5-15.6V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.4zM595 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM729.4.2h-31.5v312.5c0 8.6-4.7 15.6-10.5 15.6H656V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c-.1-17.2-9.4-31.3-21-31.3zM703 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM293.4.2H262v312.5c0 8.6-4.7 15.6-10.5 15.6H220V469c0 17.3 9.4 31.2 21 31.2h52.4c11.6 0 21-14 21-31.2V31.5c0-17.2-9.4-31.3-21-31.3zM267 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM387.5 328.4c-5.8 0-10.5-7-10.5-15.6V.2h-31.5c-11.6 0-21 14-21 31.3V469c0 17.3 9.4 31.2 21 31.2H398c11.6 0 21-14 21-31.2V328.4h-31.5zM372 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37zM502.1 328.4c-5.8 0-10.5-7-10.5-15.6V.2h-21v312.5c0 8.6-4.7 15.6-10.5 15.6h-31.5V469c0 17.3 9.4 31.2 21 31.2h62.9c11.6 0 21-14 21-31.2V328.4h-31.4zM481 477c-20.4 0-37-16.6-37-37s16.6-37 37-37 37 16.6 37 37-16.6 37-37 37z"/></g></svg>',
          route: "/identify-scales",
        },
      ],
    };
  },
  methods: {
    navigateToFeedbackForm() {
      window.open("https://www.earbeater.com/contact", "_blank");
    },
    navigateToInstructions() {
      window.open(
        "https://www.earbeater.com/how-to-use-earbeater-web/",
        "_blank"
      );
    },
    returnToExerciseList() {
      this.$store.dispatch("setShowExerciseDescription", false);
      this.$store.dispatch("setShowExerciseList", true);
    },
    showExerciseSettings() {
      this.$store.dispatch("setShowCreateExerciseSettings", true);
      this.$store.dispatch("setShowCreateExerciseSoundSequenceList", false);
    },
    showSoundSequenceList() {
      this.$store.dispatch("setShowCreateExerciseSettings", false);
      this.$store.dispatch("setShowCreateExerciseSoundSequenceList", true);
    },
  },
  computed: {
    routeTitle() {
      let name = this.$route.name;
      if (name === "IdentifyChords") {
        return "Identify Chords";
      } else if (name === "createIdentifyChordsExercise") {
        return "Create Identify Chords Exercise";
      } else if (name === "editIdentifyChordsExercise") {
        return "Edit Identify Chords Exercise";
      } else if (name === "IdentifyIntervals") {
        return "Identify Intervals";
      } else if (name === "createIdentifyIntervalsExercise") {
        return "Create Identify Intervals Exercise";
      } else if (name === "editIdentifyIntervalsExercise") {
        return "Edit Identify Intervals Exercise";
      } else if (name === "CompareIntervalSizes") {
        return "Compare Interval Sizes";
      } else if (name === "createCompareIntervalSizesExercise") {
        return "Create Identify Intervals Exercise";
      } else if (name === "editCompareIntervalSizesExercise") {
        return "Edit Compare Intervals Exercise";
      } else if (name === "IdentifyChordInversions") {
        return "Identify Chord Inversions";
      } else if (name === "createIdentifyChordInversionsExercise") {
        return "Create Identify Chord Inversion Exercise";
      } else if (name === "editIdentifyChordInversionsExercise") {
        return "Edit Identify Chord Inversion Exercise";
      } else if (name === "IdentifyScales") {
        return "Identify Scales";
      } else if (name === "createIdentifyScalesExercise") {
        return "Create Identify Scales Exercise";
      } else if (name === "editIdentifyScalesExercise") {
        return "Edit Identify Scales Exercise";
      } else if (name === "account") {
        return "Account";
      } else if (name === "settings") {
        return "Settings"
      } else {
        return "Dashboard";
      }
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    showExerciseDescription() {
      return this.$store.getters.getShowExerciseDescription;
    },
    showCreateExerciseSettings() {
      return this.$store.getters.getShowCreateExerciseSettings;
    },
    showCreateExerciseSoundSequenceList() {
      return this.$store.getters.getShowCreateExerciseSoundSequenceList;
    },
    showContinueToExerciseSettingsButton() {
      if (
        this.breakpoint.xsOnly === true &&
        this.showCreateExerciseSoundSequenceList === true
      ) {
        if (
          this.$route.path.includes("create-exercise") ||
          this.$route.path.includes("edit-exercise")
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showDashboardIcon() {
      if (this.routeTitle.includes('Create')) {
        return false;
      }
      if (this.routeTitle !== 'Dashboard' && this.showExerciseDescription === false) {
        return true;
      } 
      return false;
    },
    showBackToSoundSequenceListButton() {
      if (
        this.breakpoint.xsOnly === true &&
        this.showCreateExerciseSettings === true
      ) {
        if (
          this.$route.path.includes("create-exercise") ||
          this.$route.path.includes("edit-exercise")
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  mounted() {
    // Show login and signup dialog on correct route
    if (this.$router.currentRoute.name === 'login') {
      if (!firebase.auth().currentUser) {
        this.$store.dispatch("setShowLogInDialog", true);
      } else {
        this.$store.dispatch('setAlertDialog', this.alreadyLoggedInAlert);
      }
      
    } else {
      // this.$store.dispatch("setShowLogInDialog", false);
    }
    if (this.$router.currentRoute.name === 'signup') {
      if (!firebase.auth().currentUser) {
         this.$store.dispatch("setShowSignUpDialog", true);
      } else {
        this.$store.dispatch('setAlertDialog', this.alreadyLoggedInAlert);
      }
     
    } else {
      // this.$store.dispatch("setShowSignUpDialog", false);
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'login') {
        if (!firebase.auth().currentUser) {
          this.$store.dispatch("setShowLogInDialog", true);
        } else {
          this.$store.dispatch('setAlertDialog', this.alreadyLoggedInAlert);
        }
        
      }
      if (this.$route.name === 'signup') {
        if (!firebase.auth().currentUser) {
          this.$store.dispatch("setShowSignUpDialog", true);
        } else {
          this.$store.dispatch('setAlertDialog', this.alreadyLoggedInAlert);
        }
        
      }
    }
  }
};
</script>

<style>
nav .v-list__tile--active {
  background-color: #598888;
}
nav .eb-logo {
  height: 25px;
}
nav .headline-logo {
  width: 200px;
}

nav .discipline-title {
  display: flex;
  justify-content: center;
  width: calc(100% - 420px);
}

/* Sign in buttons smaller */
.v-btn {
  min-width: 0;
}

.st0 {
  fill: #fff;
}
.discipline-icon {
  width: 48px;
}
.v-bottom-nav .v-btn:before {
  opacity: 1;
}

.v-item-group.v-bottom-nav .v-btn--active:before {
  background-color: #598888;
}

@media only screen and (max-width: 960px) and (min-width: 600px) {
  nav .discipline-title {
    margin-left: 200px;
    font-size: 10px;
  }
}

@media screen and (max-width: 600px) {
  nav .discipline-title {
    width: 100%;
    /* margin-left: 36px; */
    font-size: 12px;
  }
}
/* Tiny old screens */
@media screen and (max-width: 380px) {
  nav .discipline-title {
    width: 100%;
    font-size: 10px;
  }
  .discipline-icon {
    width: 38px;
  }
  .v-item-group.v-bottom-nav .v-btn {
    min-width: 66px;
  }
}
</style>


